import React, { useRef, useEffect, useState } from "react";
import "./Globe.css";

export default function Globe() {
  const wrapperRef = useRef(null);
  const [isActive, setIsActive] = useState(false);

  const handleActivate = () => {
    if (!isActive) setIsActive(true);
  };

  useEffect(() => {
    const el = wrapperRef.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) setIsActive(false);
      },
      { threshold: 0.15 }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={wrapperRef}
      className={`globe-stage-wrap ${isActive ? "is-active" : ""}`}
      onMouseEnter={handleActivate}
      onTouchStart={handleActivate}
    >
      <div className="globe-sphere">
        <img src="https://res.cloudinary.com/dspelvbl1/image/upload/f_auto,q_auto/v1773091828/Globe-Base_ya4nia.png" className="globe-bg" alt="Globe base" />
        <img src="https://res.cloudinary.com/dspelvbl1/image/upload/f_auto,q_auto/v1773091832/remzy_arts_2_tnrkk8.png" className="globe-logo" alt="RemzyArts Logo" />
        <img src="https://res.cloudinary.com/dspelvbl1/image/upload/f_auto,q_auto/v1773091828/GlobeFront_kthyzw.png" className="globe-front" alt="Globe front"/>
      </div>

      <div className="satellite sat-ps"><img src="https://res.cloudinary.com/dspelvbl1/image/upload/f_auto,q_auto/v1773091832/Photoshop_Globe_omnewj.png" alt="Photoshop" /></div>
      <div className="satellite sat-figma"><img src="https://res.cloudinary.com/dspelvbl1/image/upload/f_auto,q_auto/v1773091826/Figma_Globe_ypvygd.png" alt="Figma" /></div>
      <div className="satellite sat-ai"><img src="https://res.cloudinary.com/dspelvbl1/image/upload/f_auto,q_auto/v1773091842/Illustrator_Globe_qtug2m.png" alt="Illustrator" /></div>
      <div className="satellite sat-canva"><img src="https://res.cloudinary.com/dspelvbl1/image/upload/f_auto,q_auto/v1773091827/Canva_Globe_zzibav.png" alt="Canva" /></div>
    </div>
  );
}
